// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary:hover{color:var(--el-color-primary-light-3)}.hidemenu_drop{width:13rem}.hidemenu_drop a{color:#000}.hidemenu_drop a:hover{color:#114e2d}.hidemenu_drop .el-dropdown-menu__item{text-align:center}", ""]);
// Exports
module.exports = exports;
